import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import Filers from "views/pages/bikes/filters";
import { MapComponent } from "views/pages/bikes/googleMap";
import BikeSingleInfo from "views/pages/bikes/bike-single-info";
import getProgressBar from "views/pages/bikes/helpers/get-progress-bar";
import getBatteryIcon from "views/pages/bikes/helpers/get-battery-icon";
import getLockIcon from "views/pages/bikes/helpers/get-lock-icon";
import getChargeIcon from "views/pages/bikes/helpers/get-charge-icon";
import getGpsIcon from "views/pages/bikes/helpers/get-gps-icon";
import getOnlineIcon from "views/pages/bikes/helpers/get-online-icon";
import BikesTable from "views/pages/bikes/bikes-table";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  getBikeListNoPagination,
  resetBikeListNoPagination,
  updateBikeStatus
} from "actions/bike/actions";

import settings from "utils/settings";
import { labelItems } from "./constants/map-filter-items";

const { socketUrl } = settings;

class BikesHotMap extends React.Component {
  stompClient = false;

  constructor(props) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.socketConnection = this.socketConnection.bind(this);
    this.getBikesInfoWrapper = this.getBikesInfoWrapper.bind(this);
    this.handleOpenBike = this.handleOpenBike.bind(this);

    this.state = {
      listNoPagination: this.props.listNoPagination,
      selectedBike: null,
      stompClient: this.socketConnection(),
      filters: [
        /*
        {
            fieldName: "status",
            fieldValue: [
                bikeEnumToNumStatuses.HIDDEN,
                bikeEnumToNumStatuses.FREE,
                bikeEnumToNumStatuses.BOOKED,
                bikeEnumToNumStatuses.RIDING
            ],
            searchOperation: filterTypes.IN.value
        }
        */
      ],
    };

    this.props.getBikeListNoPagination(this.state.filters);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      listNoPagination: nextProps.listNoPagination
    });
  }

  componentWillUnmount() {
    this.state.stompClient.unsubscribe("/bikes");
    this.props.resetBikeListNoPagination();
  }

  socketConnection = () => {
    const ws = new SockJS(socketUrl, null, {});
    const stompClient = Stomp.over(ws);
    stompClient.debug = () => false;
    stompClient.reconnect_delay = 3000;
    stompClient.heartbeat = {
      outgoing: 5000,
      incoming: 5000
    };
    stompClient.connect({}, () => {
      // frame
      stompClient.subscribe("/bikes", (message) => {
        this.props.getBikeListNoPagination(this.state.filters);

        /*
        const listNoPagination = JSON.parse(message.body).filter(item =>
            this.props.listNoPaginationFilteredIdArr.indexOf(item.id) > -1);
        this.setState({
            listNoPagination
        });
        */
      }, {
        id: "bikes"
      });
    }, () => {
      // frame
      // console.error("frame", frame);
      setTimeout(this.socketConnection, 3000);
    });

    return stompClient;
  };

  handleSearch = (filters) => {
    this.setState({
      filters
    }, () => {
      this.props.getBikeListNoPagination(filters);
    });
  };

  handleReset = () => {
    this.handleSearch([]);
  };

  getBikesInfoWrapper = () => {
    const { listNoPagination } = this.state;
    return (
      <div className="p-2">
        {`All bikes: ${listNoPagination.length}`}
        <hr className="mt-2 mb-2"/>
        {labelItems.map(labelItem => (
          <div key={labelItem.value} className="d-flex align-items-center justify-content-between">
            <div>
              {`${labelItem.label}: ${listNoPagination.filter(bike => bike.status === labelItem.value).length}`}
            </div>
            <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": labelItem.color }}/>
          </div>
        ))}
        <hr className="mt-1 mb-1"/>
        {`Locked: ${listNoPagination.filter(bike => bike.condition && bike.condition.closed).length}`}<br/>
        {`UNLocked: ${listNoPagination.filter(bike => bike.condition && !bike.condition.closed).length}`}<br/>
      </div>
    );
  };

  handleOpenBike = (value) => {
    const { position } = value;
    if (!position.coordinates || !Array.isArray(position.coordinates)) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    this.setState({
      selectedBike: value.id,
    });

    const modalObj = {
      id: "bike-history-position",
      modalSettings: {
        size: "sm",
        style: {
          width: 400
        }
      },
      header: "Bike Info",
      children: (
        <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
          <BikeSingleInfo
            bikeInfo={value}
            updateBikeStatus={status => this.props.updateBikeStatus(value.id, status)}
            handleClick={() => this.props.closeCustomModal(modalObj)}
          />
        </React.Suspense>
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  render() {
    // const { loading } = this.props;
    const {
      listNoPagination,
      filters,
      selectedBike
    } = this.state;

    return (
      <div className="w-100 h-100 p-2 position-relative">
        {/* !loading || <Spinner /> */}
        <div className="filters">
          <Filers
            activeFilters={filters}
            totalCount={listNoPagination.length}
            handleSearch={this.handleSearch}
            handleReset={this.handleReset}
          />
        </div>

        <div style={{
          height: "calc(100vh - 140px)"
        }}>
          <MapComponent
            center={{
              lat: 40.1870293,
              lng: 44.5129457
            }}
            zoom={12}
            markers={listNoPagination}
            info={() => this.getBikesInfoWrapper()}
            progressBar={getProgressBar}
            battery={getBatteryIcon}
            onCharge={getChargeIcon}
            onGps={getGpsIcon}
            onLine={getOnlineIcon}
            onLock={getLockIcon}
            showPositionFromMap={this.handleOpenBike}
            bikeSpeed={value => (value ? (value.speed || 0) : null)}
            selectedBike={selectedBike}
          />


          <BikesTable
            list={listNoPagination}
          />
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  // loading: state.bike.loading,
  listNoPagination: state.bike.listNoPagination,
  listNoPaginationFilteredIdArr: state.bike.listNoPaginationFilteredIdArr,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getBikeListNoPagination: bindActionCreators(getBikeListNoPagination, dispatch),
  resetBikeListNoPagination: bindActionCreators(resetBikeListNoPagination, dispatch),
  updateBikeStatus: bindActionCreators(updateBikeStatus, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(BikesHotMap);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/bikes-hot-map.js